import {
    setCookie,
    initMenuTrigger,
    addHideScrolledMenuClass,
    addFancyboxFixForGallery,
    initGallerySlider,
    addCloseCookies,
    initForm,
    googleMapInit,
    initLoadNews,
    faqService,
    initLazyBg,
    initShow
} from './functions';




import GLightbox from 'glightbox';




//import gsap from "gsap";


const mainApp = () => {

    // init lazy loading backgrounds width .lazyBg
    initLazyBg();

    initShow('animUp');
    initShow('animDown');

    // init menu trigger
    initMenuTrigger();


    // add hideScrolledMenu class management based on scroll direction
    addHideScrolledMenuClass();



    //fix gallery id for slideshow ...
    addFancyboxFixForGallery('.wp-block-gallery');
    addFancyboxFixForGallery('.wp-block-image');

    //gallerySlider
    initGallerySlider();

    // add close function to cookies
    addCloseCookies();



    //start - contact form
    initForm();

    googleMapInit();


    initLoadNews();

    faqService();




}

document.addEventListener("DOMContentLoaded", mainApp, false);


(function ($) {
    const mainAppWithJquery = () => {


        $('.subpageHeader__goDown').click(function () {
            const scrollTarget = $(this).offset().top;
            $('html,body').animate({ 'scrollTop': scrollTarget + 'px' }, 500);
        });

        $(document).on('click', '#primary-menu .menu-item-has-children', function (e) {
            if (window.innerWidth < 1200) {
                e.stopPropagation();
                if (!$(this).hasClass('active')) {
                    $(this).addClass('active');
                    $(this).parent().addClass('activeParent');
                    $('.mainHeader__menuBack').addClass('show');

                    $('.mainHeader__menuHolder')[0].scrollTop = 0;
                } else {
                    $(this).removeClass('active');
                    $(this).parent().removeClass('activeParent');
                }
            }
        });

        $(document).on('click', '.mainHeader__menuBack', function () {
            $('.activeParent:last').removeClass('activeParent');
            $('#primary-menu .menu-item.active:last').removeClass('active');
            if ($('#primary-menu .menu-item.active:last').length > 0) {
                // $('.mainHeader__menuBack').html($('.menu-item.active:last').find('>a').html());
            } else {
                // $('.mainHeader__menuBack').html('');
                $('.mainHeader__menuBack').removeClass('show');
            }
        });
        $(document).on('click', '.menuTrigger', function () {
            $('.activeParent').removeClass('activeParent');
            $('#primary-menu .menu-item.active').removeClass('active');
            $('.mainHeader__menuBack').removeClass('show');

        });


        const viewportWidth = window.innerWidth;
        $('#primary-menu  a[href*="|"]').each(function (e) {

            let url = $(this).attr('href');
            let split_url = url.split('|');
            if (viewportWidth <= 782) {
                $(this).attr('href', split_url[0]);
            } else {
                $(this).attr('href', split_url[1]);
            }
        });

        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();
            var target = $(this).attr('href');
            if (target.length > 1) {
                var targetOffset = $(target).offset().top - 140;
                $('html, body').animate({
                    scrollTop: targetOffset
                }, 500);
            }
            return false;
        });


        if (window.location.hash) {
            window.setTimeout(() => {
                var target = window.location.hash;
                if ($(target).length > 0) {
                    var targetOffset = $(target).offset().top - 140;
                    $('html, body').animate({
                        scrollTop: targetOffset
                    }, 500);
                }
            }, 500);

        }

        $('.gAtuty__menuItem').on('click', function () {
            const target = $(this).data('target');
            $('.gAtuty__menuItem').removeClass('active');
            $(this).addClass('active');
            $('.gAtuty__contentItem').removeClass('active');
            $(`.gAtuty__contentItem#${target}`).addClass('active');

        });




        //sliders
        if ($('.gProjects__itemGalleryList').length > 0) {
            $('.gProjects__itemGalleryList').each(function () {
                const $slider = $(this);

                $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
                    const current = (typeof currentSlide === 'undefined' ? 0 : currentSlide) + 1;
                    const total = slick.slideCount;
                    let $counter = $slider.find('.slick-counter').first();
                    if ($counter.length === 0) {
                        $counter = $('<div class="slick-counter"></div>');
                        $slider.append($counter);
                    }
                    $counter.text(current + '/' + total);
                });

                $slider.slick({
                    infinite: true,
                    arrows: true,
                    dots: false,
                    autoplay: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 500,
                    autoplaySpeed: 10000,
                    fade: true,
                    cssEase: 'linear'
                });
            });

        }

        const lightbox = GLightbox({
            selector: ".woocommerce-product-gallery__image a,.glightbox, .wp-block-image a[href$='.jpg'], .wp-block-image a[href$='.jpeg'], .wp-block-image a[href$='.png'], .wp-block-image.glightbox a",
            slideEffect: 'fade',
            loop: true,
            dragAutoSnap: true,
        });




    };
    document.addEventListener("DOMContentLoaded", mainAppWithJquery, false);

})(jQuery);








